<template>
  <section id="gamer-details">
    <gamer-select></gamer-select>
    <gamer-earnings></gamer-earnings>
  </section>
</template>

<style lang="scss" scoped>
#gamer-details {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  font-size: 20px;
  font-weight: bold;
}
</style>

<script>
import GamerSelect from "@/components/GamerSalary/GamerSelect";
import GamerEarnings from "@/components/GamerSalary/GamerEarnings";
export default {
  components: {
    GamerSelect,
    GamerEarnings,
  },
  beforeMount(){
      this.$store.commit("setGamerData");
  }
};
</script>